import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import useHttpHook from "../../../Hooks/HttpHook";
import { EditGuardApi, GetGuardById } from "../../../utils/ApiConstant";
import { GuardLanguage } from "../../../utils/Languages";
import MainComponentWrapper from "../../Common/MainComponentWrapper";
import ModalWrapper from "../../Common/Portals/ModalWrapper";
import Input from "../../UiElement/FormElement/Input";
import { toast } from "react-toastify";
import { showErrorToast } from "../../../utils/notify";

const EditGuard = ({
  guardId,
  setIsOpen,
  getOrganizerGuardsList,
  setSelectedGuard,
}) => {
  const [loading, sendRequest, error] = useHttpHook();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();
  const [dobError, setDobError] = useState("");
  const gender = [
    {
      title: "male",
    },
    {
      title: "female",
    },
    {
      title: "other",
    },
  ];

  useEffect(() => {
    getGuardDetails();
  }, []);

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
              window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);
  const getGuardDetails = async () => {
    try {
      const res = await sendRequest(`${GetGuardById}/${guardId}`, {
        method: "get",
      });
      if (res.status === 1) {
        console.log({
          phone: parseInt(res.data.phone),
        });
        const obj = {
          name: res.data.name,
          userName: res.data.userName,
          email: res.data.email,
          phone: parseInt(res.data.phone),
          //   password: res.data.password,
          dob: res.data.dob,
          gender: res.data.gender,
        };
        reset(obj);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleEdit = async (data) => {
    try {
      let dob = new Date(data.dob);

      if (dob > Date.now()) {
        setDobError("Date of Birth should be less than current date");
        return;
      }

      const res = await sendRequest(`${EditGuardApi}/${guardId}`, {
        method: "PUT",
        data,
      });
      if (res.status === 1) {
        setIsOpen(false);
        getOrganizerGuardsList();
        setSelectedGuard("");
      }
    } catch (error) {
      console.log({ error });
    }
  };

  return (
    <MainComponentWrapper errorInfo={error} Loading={loading}>
      <ModalWrapper
        title={GuardLanguage.Edit.Heading}
        submitText={GuardLanguage.Edit.submitText}
        formId="editGuard"
        CloseModalHandler={() => setIsOpen(false)}
        dialogClassName="event-guard-modal-dialog"
        contentClassName="event-guard-modal"
        headerClassName="event-guard-modal-header"
        bodyClassName="event-guard-modal-body"
        footerClassName="event-guard-modal-footer"
        closeClass="event-guard-modal-btn-close"
        submitClass="event-guard-modal-btn-primary"
      >
        <form
          className="event-guard-form"
          onSubmit={handleSubmit(handleEdit)}
          id="editGuard"
        >
          <Input
            ValidationArr={[{ Type: "required" }]}
            WrapperClass="col-lg-12"
            element="text"
            FieldName="name"
            Register={register}
            Errors={errors}
            placeholder={GuardLanguage.Assign.form.name.placeHolder}
            Label={GuardLanguage.Assign.form.name.label}
          />
          <Input
            ValidationArr={[{ Type: "required" }]}
            WrapperClass="col-lg-12"
            element="text"
            FieldName="email"
            Register={register}
            Errors={errors}
            placeholder={GuardLanguage.Assign.form.email.placeHolder}
            Label={GuardLanguage.Assign.form.email.label}
          />
          <Input
            ValidationArr={[{ Type: "required" }]}
            WrapperClass="col-lg-12"
            element="text"
            FieldName="userName"
            Register={register}
            Errors={errors}
            placeholder={GuardLanguage.Assign.form.username.placeHolder}
            Label={GuardLanguage.Assign.form.username.label}
          />
          {/* <Input
            ValidationArr={[{ Type: "required" }]}
            WrapperClass="col-lg-12"
            element="password"
            FieldName="password"
            Register={register}
            Errors={errors}
            placeholder={GuardLanguage.Assign.form.password.placeHolder}
            Label={GuardLanguage.Assign.form.password.label}
          /> */}
          <Input
            ValidationArr={[{ Type: "required" }]}
            WrapperClass="col-lg-12"
            element="date"
            FieldName="dob"
            Register={register}
            Errors={errors}
            Label={GuardLanguage.Assign.form.dob.label}
          />
          {dobError && (
            <div className="col mb-3 d-flex justify-content-center text-align-center">
              <div className="col-md-12 text-align-center">
                <div
                  className="text-danger"
                  style={{
                    fontSize: "14px",
                  }}
                >
                  {dobError}
                </div>
              </div>
            </div>
          )}
          <Input
            ValidationArr={[{ Type: "required" }]}
            WrapperClass="col-lg-12"
            element="select"
            FieldName="gender"
            Register={register}
            Errors={errors}
            Label={GuardLanguage.Assign.form.gender.label}
            options={gender}
            optionValue="title"
            optionLabel="title"
          />
          <Input
            ValidationArr={[{ Type: "required" }]}
            WrapperClass="col-lg-12"
            element="number"
            FieldName="phone"
            Register={register}
            Errors={errors}
            placeholder={GuardLanguage.Assign.form.phone.placeHolder}
            Label={GuardLanguage.Assign.form.phone.label}
          />
        </form>
      </ModalWrapper>
    </MainComponentWrapper>
  );
};

export default EditGuard;
